import { contactUs } from 'helpers/api';

const state = {
    form: null,
    fields: [],
    error: false,
};

// ==================================================
// HANDLERS
// ==================================================

async function handleSubmit(e) {
    e.preventDefault();

    const errorBody = state.form.getElementsByClassName('js--contact-error')[0];
    state.error = false;

    state.fields.forEach((k) => {
        if (k.value.length < 2) {
            k.classList.add('contact--error');
            state.error = true;
        }
    });

    if (state.error) {
        return;
    }

    const { status, data } = await contactUs(state.form);

    if (status !== 200) {
        errorBody.classList.remove('none');
        return (errorBody.innerHTML = data.Message || 'There was an error submiting your request.');
    }

    errorBody.classList.add('none');
    state.form.reset();
    state.form.getElementsByClassName('js--contact-success')[0].classList.remove('none');
}

function handleFieldChange(e) {
    if (e.target.classList.contains('contact--error')) {
        e.target.classList.remove('contact--error');
    }
}

// ==================================================
// INIT
// ==================================================

function init() {
    [state.form] = document.getElementsByClassName('js--contact-form');
    state.form.addEventListener('submit', (e) => handleSubmit(e));
    state.fields = Array.from(state.form.getElementsByClassName('js--input'));

    Array.from(state.form.getElementsByClassName('js--input')).forEach((k) => {
        const evtType = k.nodeName === 'SELECT' ? 'change' : 'keyup';
        k.addEventListener(evtType, (e) => handleFieldChange(e));
    });
}

export default init;
